
import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { MatList } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { IconModule } from '@ogs-gmbh/ngx-m3-components';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-column-menu',
  standalone: true,
  imports: [ MatMenuModule, IconModule, MatList ],
  templateUrl: './table-column-menu.component.html',
  styleUrl: './table-column-menu.component.scss'
})
export class TableColumnMenuComponent {
  @HostListener('click', [ '$event' ])
  // eslint-disable-next-line @tseslint/class-methods-use-this, @tseslint/no-shadow
  onMenuClick (event: MouseEvent): void {
    event.stopPropagation();
  }
}
